// extracted by mini-css-extract-plugin
export default {"companyContainer":"dN-z","companyImage":"eN-z","container":"fN-z","heading":"gN-z","darkText":"hN-z","smallHeading":"iN-z","darkBackground":"jN-z","whiteBackground":"kN-z"};